import React, { useState } from "react";
import { useApp } from "../../context/AppContext";
import { toast } from "../ui/sonner";
import { FileDown, Mail } from "lucide-react";

export default function BriefingCard() {
  const { api, lang, user } = useApp();
  const zh = lang === "zh";
  const [emailing, setEmailing] = useState(false);
  const canEmail = ["admin", "ceo", "sales_vp"].includes(user.role);

  const download = async () => {
    try {
      const res = await api.get("/reports/monthly-briefing-pdf", { params: { lang }, responseType: "blob" });
      const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = url; a.download = "monthly_briefing.pdf"; document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
    } catch { toast.error(zh ? "简报生成失败" : "Briefing failed"); }
  };

  const email = async () => {
    setEmailing(true);
    try {
      const { data } = await api.post("/reports/monthly-briefing-email", { lang });
      const ok = (data.results || []).filter((r) => r.ok).length;
      toast.success(zh ? `已向 ${data.recipients.length} 位管理层发送经营简报，成功 ${ok} 封` : `Sent to ${data.recipients.length}; ${ok} delivered`);
    } catch (e) { toast.error(e?.response?.data?.detail || e.message); }
    setEmailing(false);
  };

  return (
    <div className="bg-slate-900 rounded-xl p-5 flex flex-wrap items-center justify-between gap-3" data-testid="cockpit-briefing">
      <div>
        <h3 className="font-semibold text-white flex items-center gap-2"><FileDown className="h-4 w-4 text-red-400" />{zh ? "月度经营简报" : "Monthly Operations Briefing"}</h3>
        <p className="text-slate-400 text-xs mt-1">{zh ? "一份 PDF 汇总施工效率趋势 + 销售业绩排行，可下载或群发管理层" : "One PDF combining efficiency trend + sales ranking"}</p>
      </div>
      <div className="flex items-center gap-2">
        <button data-testid="cockpit-briefing-download" onClick={download} className="inline-flex items-center gap-1.5 text-sm text-white border border-slate-600 hover:border-brand-400 hover:text-brand-300 rounded-lg px-3 py-2 transition-colors">
          <FileDown className="h-4 w-4" />{zh ? "下载简报 PDF" : "Download PDF"}
        </button>
        {canEmail && (
          <button data-testid="cockpit-briefing-email" onClick={email} disabled={emailing} className="inline-flex items-center gap-1.5 text-sm text-white bg-brand-500 hover:bg-brand-600 disabled:opacity-50 rounded-lg px-3 py-2 transition-colors">
            <Mail className="h-4 w-4" />{emailing ? (zh ? "发送中…" : "Sending…") : (zh ? "发管理层" : "Email Mgmt")}
          </button>
        )}
      </div>
    </div>
  );
}
